import styled from "@emotion/styled";
import { text, surface, fontSize, spacing } from "@atlas-int/tokens";

interface MenuOptionProps {
  $selected?: boolean;
}

const MenuOption = styled.div<MenuOptionProps>`
  display: flex;
  align-items: center;
  padding: ${spacing[4]} ${spacing[8]};
  font-size: ${fontSize.base};
  color: ${text.primary};
  cursor: pointer;
  white-space: nowrap;
  background-color: ${({ $selected }) => ($selected ? surface.hover : "transparent")};

  &:hover {
    background-color: ${surface.hover};
  }
`;

export default MenuOption;
